var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" Unknown Viewer "),_c('pre',[_vm._v(_vm._s(_vm.container))]),_c('pre',[_vm._v(_vm._s(_vm.media))])])}
var staticRenderFns = []

export { render, staticRenderFns }